<template>
    <div
        :id="id"
        class="container-block"
        :data-direction="direction"
        :data-index-path="indexPath"
        :style="containerStyle"
    >
        <template
            v-for="(child) in children"
            :key="child.id"
        >
            <CustomPageBlock
                :block="child"
                :model-value="child.currentValue"
                :data-testid="`custom-page-block-${kebabCase((child as ExtendedBlock<CPInputConfiguration>).fieldName || child.type)}`"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { kebabCase } from 'change-case'
import type { CPInputConfiguration, ExtendedBlock } from 'widget-components/integrations/CustomPage/types'
import type { StickyPosition } from 'widget-components/components/Container/container-sticky-position'
import { CustomPageBlock } from 'widget-components/integrations/CustomPage'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    children: ExtendedBlock[]
    gap?: string
    direction?: string
    alignItems?: string
    justifyContent?: string
    stickyPosition?: StickyPosition
    flexMultiplier?: number
    indexPath?: number[]
}>()

const containerStyle = computed(() => ({
    '--direction': props.direction,
    '--gap': props.gap,
    '--align-items': props.alignItems,
    '--justify-content': props.justifyContent,
}))

</script>

<style lang="sass" scoped>
@import "./Container.sass"
</style>

